<template>
  <div class="Top" :class="{ 'is-scrolled': isScrolled, 'is-hidden': isHidden }">
    <div class="header-container">
      <!-- 左侧Logo -->
      <div class="logo" @click="goHome">
        <img src="@/assets/logo.png" alt="智步云上模型网" class="logo-img" />
      </div>

      <!-- 中间导航+搜索区 -->
      <div class="middle-section">
        <!-- 主导航菜单 -->
        <nav class="main-nav" :class="{ hidden: isMobileMenuHidden }">
          <ul>
            <li @click="goHome()" :class="{ active: $route.path === '/' }">首页</li>
            <li class="nav-item" :class="{ active: isModelsCategoryActive }">
              模型分类
              <div class="submenu">
                <div class="submenu_filter" v-for="(item, index) in submenuList" :key="index">
                  <span @click="SearchType(item.label)" class="anchor-link">{{ item.label }}</span>
                </div>
              </div>
              <div class="kind">
                <div class="submenu_filter" v-for="(item, index) in kindList" :key="index">
                  <span @click="SearchType(item.label)" class="anchor-link">{{ item.label }}</span>
                </div>
              </div>
            </li>
            <li @click="goToModelsRecommend()" :class="{ active: $route.path === '/hotModels' }">3D模型</li>
            <li @click="goToModelsArtist()" :class="{ active: $route.path === '/designers' }">模型师</li>
            <li @click="goToJoinUs()" :class="{ active: $route.path === '/contact' }">模型定制</li>
          </ul>
        </nav>
      </div>

      <!-- 右侧功能区 -->
      <div class="right-section">
        <!-- 加载中骨架屏 -->
        <div v-if="isCheckingAuth" class="user-skeleton">
          <div class="skeleton-circle"></div>
          <div class="skeleton-line"></div>
        </div>

        <template v-else>
          <!-- 通知图标 -->
          <div class="notification-icon" @mouseenter="showNotificationPanel = true; clearNotificationTimer()"
            @mouseleave="handleNotificationPanelLeave" ref="notificationIcon" v-if="isLoggedIn">
            <i class="el-icon-message-solid"></i>
            <span class="notification-badge" v-if="unreadCount > 0">{{ unreadBadgeText }}</span>

            <div class="notification-panel" v-show="showNotificationPanel" ref="notificationPanel"
              @mouseenter="clearNotificationTimer()" @mouseleave="handleNotificationPanelLeave">
              <div class="notification-header">
                <h3>通知中心</h3>
                <div class="notification-actions">
                  <span class="mark-all-read" @click.stop="markAllAsRead">标记全部已读</span>
                  <span class="clear-all" @click.stop="clearAllNotifications">清空</span>
                </div>
              </div>
              <div class="notification-list" v-if="notificationList.length > 0">
                <div class="notification-item" v-for="notification in notificationList" :key="notification.id"
                  :class="{ unread: !notification.read }">
                  <div class="notification-content">
                    <span class="notification-dot" v-if="!notification.read"></span>
                    <p class="notification-text">{{ notification.content }}</p>
                    <span class="notification-time">{{ notification.time }}</span>
                  </div>
                  <div class="notification-action">
                    <span class="mark-read-btn" @click.stop="markAsRead(notification.id)" v-if="!notification.read">
                      标为已读
                    </span>
                    <span class="read-status" v-else>已读</span>
                  </div>
                </div>
              </div>
              <div class="empty-notification" v-else>
                <i class="el-icon-message-solid-o"></i>
                <p>暂无通知</p>
              </div>
            </div>
          </div>

          <!-- 登录/头像区域 -->
          <div class="user-area">
            <button class="login-btn" @click="handleLogin" v-if="!isLoggedIn">
              {{ isMobile ? '登录' : '登录/注册' }}
            </button>
            <div class="avatar-container" v-else @click="toggleUserMenu">
              <span class="user-coins" v-if="!isMobile">
                <i class="el-icon-coin"></i>
                {{ topUpInfo.remainingSum || 0 }}
              </span>
              <img :src="userInfo.avatar || defaultAvatar" alt="用户头像" class="user-avatar" />
              <i class="icon-arrow-down" :class="{ 'rotate': showUserMenu }"></i>
              <span class="user-name" v-if="!isMobile">{{ userName || '未知用户' }}</span>
              <div class="user-menu" v-if="showUserMenu">
                <div class="menu-item" @click="goToBuyerCenter">
                  <i class="el-icon-shopping-cart-2"></i> 买家中心
                </div>
                <div class="menu-item" @click="goToSellerCenter">
                  <i class="el-icon-s-shop"></i> 卖家中心
                </div>
                <div class="menu-item" @click="goToUpload">
                  <i class="el-icon-upload2"></i> 模型投稿
                </div>
                <div class="divider"></div>
                <div class="menu-item logout" @click="handleLogout">
                  <i class="el-icon-switch-button"></i> 退出登录
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- 移动端菜单按钮 -->
        <button class="mobile-menu-btn" @click="toggleMobileMenu" v-if="isMobile">
          <i :class="showMobileMenu ? 'el-icon-close' : 'el-icon-menu'"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['reload'],
  data() {
    return {
      topUpInfo: { remainingSum: 0 }, // 初始化余额默认值
      submenuList: [
        { label: '免费3D模型' },
        { label: '3ds Max模型' },
        { label: 'Maya模型' },
        { label: 'Cinema 4D模型' },
        { label: 'Obj模型' },
        { label: 'FBX模型' },
        { label: '有动画模型' },
        { label: '有绑定模型' },
        { label: 'Unity' },
        { label: 'Unreal Engine' }
      ],
      kindList: [
        { label: '人物' }, { label: '动物' }, { label: '石头植物' },
        { label: '雕塑/文物' }, { label: '车辆' }, { label: '船艇' },
        { label: '飞机/航天' }, { label: '机械/器械' }, { label: '建筑' },
        { label: '展厅' }, { label: '场景' }, { label: '武器' },
        { label: '电子电器' }, { label: '家具' }, { label: '生活用品' },
        { label: '食品/饮料/药品' }, { label: '家装' }, { label: '特效动画/插件' },
        { label: '工装' }, { label: '美陈' }, { label: '电商' },
        { label: '舞美/会议' }, { label: '微生物' }, { label: '生物结构' },
        { label: '展台' }
      ],
      searchKey: '',
      allResults: [],
      filteredResults: [],
      showDropdown: false,
      hoverIndex: -1,
      searchDebounce: null,
      isBlur: false,

      isCheckingAuth: true,
      isLoggedIn: false,
      userInfo: { avatar: '', id: '' },
      defaultAvatar: 'http://49.232.163.2:5159/image/30.png', // 固定默认头像
      showUserMenu: false,
      userName: '',

      isScrolled: false,
      isHidden: false,
      lastScrollY: 0,

      isMobile: false,
      showMobileMenu: false,
      isMobileMenuHidden: false,
      mobileSubmenu: { category: false },
      token: localStorage.getItem('token'),

      notificationList: [],
      showNotificationPanel: false,
      panelLeaveTimer: null,
      websocket: null,
      reconnectTimer: null,
      reconnectCount: 0,
      maxReconnectCount: 10,
      isWebSocketConnected: false,
      wsUrl: 'ws://49.232.163.2:5159/ws/notification',

      _isDestroyed: false,
      _pendingRequests: []
    }
  },
  computed: {
    isModelsCategoryActive() {
      return this.$route.path === '/type';
    },
    unreadCount() {
      return this.notificationList.filter(item => !item.read).length;
    },
    unreadBadgeText() {
      return this.unreadCount > 99 ? '99+' : this.unreadCount;
    }
  },

  mounted() {
    // 优先从本地缓存加载用户信息（关键：兜底）
    this.loadUserInfoFromLocalStorage();
    this.initAuthState();
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.avatar-container')) {
        this.showUserMenu = false;
      }
      if (!e.target.closest('.notification-icon')) {
        this.showNotificationPanel = false;
      }
    });

    window.addEventListener('beforeunload', this.handleBeforeUnload);
    // 监听本地存储变化（跨标签页登录同步）
    window.addEventListener('storage', this.handleStorageChange);
  },

  activated() {
    this.initAuthState();
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.initAuthState();
    });
  },

  watch: {
    '$route.path': {
      handler(newVal) {
        if (newVal === '/') {
          this.initAuthState();
        }
      }
    },
    // 监听token变化，强制同步状态
    token(newVal) {
      if (newVal) {
        this.initAuthState();
      } else {
        this.resetUserState();
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this._isDestroyed = true;
    this._pendingRequests.forEach(request => {
      if (request && typeof request.abort === 'function') {
        request.abort();
      }
    });
    this._pendingRequests = [];
    next();
  },

  beforeDestroy() {
    this._isDestroyed = true;
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    window.removeEventListener('storage', this.handleStorageChange);
    this.clearNotificationTimer();
    this.closeWebSocket();
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
    }
  },

  methods: {
    // 监听本地存储变化（跨标签页同步）
    handleStorageChange(e) {
      if (e.key === 'token' || e.key === 'userData') {
        this.token = localStorage.getItem('token');
        this.loadUserInfoFromLocalStorage();
        this.initAuthState();
      }
    },

    handleBeforeUnload() {
      this._isDestroyed = true;
      this.closeWebSocket();
    },

    // 从本地缓存加载用户信息（兜底核心）
    loadUserInfoFromLocalStorage() {
      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const parsed = JSON.parse(userData);
          this.userName = parsed.userName || '';
          this.userInfo.avatar = parsed.avatar || this.defaultAvatar;
          this.userInfo.id = parsed.userID || '';
        } catch (err) {
          console.error('解析本地用户信息失败:', err);
        }
      }
    },

    // 重置用户状态（登出/401时调用）
    resetUserState() {
      this.isLoggedIn = false;
      this.userInfo = { avatar: '', id: '' };
      this.userName = '';
      this.topUpInfo = { remainingSum: 0 };
      this.token = null;
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      this.closeWebSocket();
      this.isCheckingAuth = false;
    },

    // 初始化认证状态（核心修复）
    initAuthState() {
      this.isCheckingAuth = true;
      const token = localStorage.getItem('token');
      this.token = token;

      if (token) {
        // 先基于本地缓存设为已登录（避免接口请求中显示登录按钮）
        this.isLoggedIn = !!localStorage.getItem('userData');
        // 异步请求最新用户信息，失败则用本地缓存兜底
        this.getUserInt().catch(() => {
          // 接口失败但有本地缓存，仍保持登录状态
          if (localStorage.getItem('userData')) {
            this.isLoggedIn = true;
            this.isCheckingAuth = false;
          } else {
            this.resetUserState();
          }
        });
      } else {
        this.resetUserState();
      }
    },

    handleScroll() {
      const currentScrollY = window.scrollY;
      // 只保留滚动样式，永远不隐藏
      this.isScrolled = currentScrollY > 50;
      // 强制关闭隐藏
      this.isHidden = false;
    },

    initRealWebSocket() {
      if (!this.token || this.websocket) return;

      try {
        const wsUrlWithToken = `${this.wsUrl}?token=${encodeURIComponent(this.token)}`;
        this.websocket = new WebSocket(wsUrlWithToken);
        this.websocket.onopen = (event) => {
          console.log('WebSocket 连接成功', event);
          this.isWebSocketConnected = true;
          this.reconnectCount = 0;
          if (this.reconnectTimer) clearTimeout(this.reconnectTimer);
        };
        this.websocket.onmessage = (event) => {
          try {
            const message = JSON.parse(event.data);
            if (message.type === 'notification' && message.content) {
              this.notificationList.unshift({
                id: message.id || Date.now(),
                content: message.content,
                time: message.createTime || new Date().toLocaleString(),
                read: false,
                type: message.notificationType || 'system'
              });
              this.showDesktopNotification(message.content);
            }
          } catch (error) {
            console.error('解析WebSocket消息失败:', error);
          }
        };
        this.websocket.onclose = (event) => {
          this.isWebSocketConnected = false;
          if (event.code !== 1000 && !this._isDestroyed) {
            this.autoReconnect();
          }
        };
        this.websocket.onerror = (error) => {
          this.isWebSocketConnected = false;
          if (!this._isDestroyed) {
            this.autoReconnect();
          }
        };
      } catch (error) {
        if (!this._isDestroyed) {
          this.autoReconnect();
        }
      }
    },

    autoReconnect() {
      if (this.reconnectCount >= this.maxReconnectCount || this._isDestroyed) return;
      if (this.reconnectTimer) clearTimeout(this.reconnectTimer);
      const delay = Math.min(1000 * Math.pow(2, this.reconnectCount), 30000);
      this.reconnectTimer = setTimeout(() => {
        this.reconnectCount++;
        this.initRealWebSocket();
      }, delay);
    },

    sendWebSocketMessage(data) {
      if (this.isWebSocketConnected && this.websocket && this.websocket.readyState === WebSocket.OPEN) {
        try {
          this.websocket.send(JSON.stringify(data));
        } catch (error) {
          console.error('发送WebSocket消息失败:', error);
        }
      }
    },

    closeWebSocket() {
      if (this.websocket) {
        try {
          this.websocket.close(1000, '正常关闭');
        } catch (error) {
          console.error('关闭WebSocket失败:', error);
        } finally {
          this.websocket = null;
          this.isWebSocketConnected = false;
        }
      }
    },

    showDesktopNotification(content) {
      if (!("Notification" in window)) return;
      if (Notification.permission === "granted") {
        new Notification("智步云上模型网", {
          body: content,
          icon: "@/assets/logo1.png",
          requireInteraction: false
        });
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(permission => {
          if (permission === "granted") {
            new Notification("智步云上模型网", {
              body: content,
              icon: "@/assets/logo1.png"
            });
          }
        });
      }
    },

    clearNotificationTimer() {
      if (this.panelLeaveTimer) {
        clearTimeout(this.panelLeaveTimer);
        this.panelLeaveTimer = null;
      }
    },

    handleNotificationPanelLeave() {
      this.panelLeaveTimer = setTimeout(() => {
        this.showNotificationPanel = false;
      }, 300);
    },

    markAsRead(notificationId) {
      const index = this.notificationList.findIndex(item => item.id === notificationId);
      if (index !== -1) {
        this.$set(this.notificationList[index], 'read', true);
        this.sendWebSocketMessage({ type: 'mark_read', notificationId: notificationId });
        this.$apiFun.getUpNotification({ notificationId: notificationId }).then(res => {
          if (res.status !== 200) {
            this.$set(this.notificationList[index], 'read', false);
          }
        }).catch(() => {
          this.$set(this.notificationList[index], 'read', false);
        });
      }
    },

    markAllAsRead() {
      this.notificationList.forEach(notification => {
        this.$set(notification, 'read', true);
      });
      this.sendWebSocketMessage({ type: 'mark_all_read' });
      this.$apiFun.getUpNotifications().then(res => {
        if (res.status !== 200) {
          this.notificationList.forEach(notification => {
            this.$set(notification, 'read', false);
          });
        }
      }).catch(() => {
        this.notificationList.forEach(notification => {
          this.$set(notification, 'read', false);
        });
      });
      this.$message.success('所有通知已标记为已读');
    },

    clearAllNotifications() {
      this.$confirm('确定要清空所有通知吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const backupList = [...this.notificationList];
        this.notificationList = [];
        this.sendWebSocketMessage({ type: 'clear_notifications' });
        this.$apiFun.getDeNotifications().then(res => {
          if (res.status !== 200) {
            this.notificationList = backupList;
          }
        }).catch(() => {
          this.notificationList = backupList;
        });
        this.$message.success('通知已清空');
      }).catch(() => { });
    },

    TopUpCenter() {
      this.$apiFun.getTopUpCenter()
        .then(res => {
          if (res.status === 200) {
            this.topUpInfo = res.obj || { remainingSum: 0 };
          }
        })
        .catch(err => {
          console.error('充值中心信息加载失败:', err);
          this.topUpInfo = { remainingSum: 0 };
        });
    },

    handleResize() {
      const screenWidth = window.innerWidth;
      this.isMobile = screenWidth < 768;
      this.isMobileMenuHidden = screenWidth < 992 && !this.isMobile;
      if (screenWidth >= 768) {
        this.showMobileMenu = false;
        this.mobileSubmenu.category = false;
      }
    },

    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
      if (this.showMobileMenu) {
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = '17px';
      } else {
        setTimeout(() => {
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
        }, 0);
      }
    },

    toggleMobileSubmenu(type) {
      this.mobileSubmenu[type] = !this.mobileSubmenu[type];
    },

    SearchType(label) {
      const routeInfo = this.$router.resolve({
        path: '/type',
        query: { type: label }
      });
      window.open(routeInfo.href, '_blank');
    },

    // 获取用户信息（返回Promise，支持catch容错）
    async getUserInt() {
      if (this._isDestroyed) {
        this.isCheckingAuth = false;
        return Promise.reject('组件已销毁');
      }

      try {
        const res = await this.$apiFun.getUserInt();
        if (this._isDestroyed) return Promise.resolve();

        if (res.status === 200) {
          // 更新用户信息
          this.userName = res.obj.userName || '';
          this.userInfo.id = res.obj.userID || '';
          this.userInfo.avatar = res.obj.userAvatar || this.defaultAvatar;
          this.isLoggedIn = true;
          this.token = localStorage.getItem('token');

          // 缓存到本地（关键：刷新时兜底）
          localStorage.setItem('userData', JSON.stringify({
            userName: this.userName,
            avatar: this.userInfo.avatar,
            userID: this.userInfo.id
          }));

          // 加载其他数据
          this.fetchNotificationList();
          this.initRealWebSocket();
          this.TopUpCenter();
          this.isCheckingAuth = false;
          return Promise.resolve(res.obj);
        } else {
          throw new Error(`接口返回异常：${res.status}`);
        }
      } catch (err) {
        if (this._isDestroyed) {
          this.isCheckingAuth = false;
          return Promise.reject(err);
        }

        console.error('获取用户信息失败:', err);
        // 401 才清除状态，其他错误（网络/超时）保留本地缓存
        if (err?.response?.status === 401 || err?.status === 401) {
          this.resetUserState();
        } else {
          this.isCheckingAuth = false;
        }
        return Promise.reject(err);
      }
    },

    fetchNotificationList() {
      if (this._isDestroyed) return;

      this.$apiFun.getNotification()
        .then(res => {
          if (this._isDestroyed) return;
          if (res.status === 200) {
            this.notificationList = res.obj || [];
          }
        })
        .catch(err => {
          if (this._isDestroyed) return;
          console.error('拉取通知列表失败:', err);
        });
    },

    goHome() {
      this.$router.push('/');
    },

    goToModelsRecommend() {
      this.$router.push('/hotModels');
    },

    goToModelsArtist() {
      this.$router.push('/designers');
    },

    goToJoinUs() {
      if (this.token) {
        this.$router.push('/contact');
      } else {
        this.$message.warning('请先登录后再进行联系操作');
        this.$router.push('/login');
      }
    },

    handleInput() {
      clearTimeout(this.searchDebounce);
      if (!this.searchKey.trim()) {
        this.allResults = [];
        this.filteredResults = [];
        this.showDropdown = false;
        return;
      }
      this.searchDebounce = setTimeout(() => {
        this.fetchFuzzySearch();
      }, 300);
    },

    fetchFuzzySearch() {
      this.$apiFun.getHomePageSearch({ title: this.searchKey })
        .then(res => {
          if (res.status === 200) {
            this.allResults = res.obj.map(item => item.title).slice(0, 10);
            this.filteredResults = [...this.allResults];
            this.showDropdown = true;
          }
        })
        .catch(err => {
          console.error('模糊查询失败:', err);
        });
    },

    highlightMatch(text) {
      if (!this.searchKey) return text;
      const regex = new RegExp(`(${this.searchKey})`, 'gi');
      return text.replace(regex, '<span class="highlight-text">$1</span>');
    },

    handleFocus() {
      this.isBlur = false;
      if (this.searchKey.trim() && this.allResults.length > 0) {
        this.showDropdown = true;
      }
    },

    handleBlur() {
      this.isBlur = true;
      setTimeout(() => {
        if (this.isBlur) {
          this.showDropdown = false;
        }
      }, 200);
    },

    handleSelectItem(item) {
      this.searchKey = item;
      this.showDropdown = false;
      this.handleSearch();
    },

    handleSearch() {
      const keyword = this.searchKey.trim();
      if (!keyword) {
        this.$message.warning('请输入搜索关键词');
        return;
      }
      const routeInfo = this.$router.resolve({
        path: '/search',
        query: { title: keyword }
      });
      window.open(routeInfo.href, '_blank');
    },

    handleLogin() {
      localStorage.setItem('redirectPath', this.$route.fullPath);
      this.$router.push('/login');
    },

    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu;
    },

    goToBuyerCenter() {
      this.showUserMenu = false;
      this.$router.push('/dashboard/buyer/home');
    },

    goToSellerCenter() {
      this.showUserMenu = false;
      this.$router.push('/dashboard/seller/home');
    },

    goToUpload() {
      this.showUserMenu = false;
      this.$router.push('/upload');
    },

    handleLogout() {
      this.$apiFun.getLogout()
        .then(res => {
          if (res.status === 200) {
            this.$message.success('退出登录成功');
          }
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          // 无论接口是否成功，都重置状态
          this.resetUserState();
          if (this.$route.meta.requiresAuth) {
            this.$router.push('/');
          }
        });
    }
  }
}
</script>

<style lang="less">
// 主题色定义
@base-deep: #0f1118;
@base-darker: #080a12;
@primary: #0ea5e9;
@primary-light: #38bdf8;
@accent: #7c3aed;
@text-primary: #fff;
@text-secondary: #94a3b8;
@border-color: rgba(148, 163, 184, 0.1);
@notification-red: #ef4444;
@notification-bg: #1e293b;
@unread-bg: rgba(14, 165, 233, 0.1);
@glass-bg: rgba(15, 17, 24, 0.85);

@sm: 576px;
@md: 768px;
@lg: 992px;
@xl: 1200px;
@xxl: 1600px;

.Top {
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  background: @base-deep;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;

  transition: background-color 0.3s ease,
    border-color 0.3s ease,
    box-shadow 0.3s ease;

  border-bottom: 1px solid transparent;

  background: linear-gradient(to bottom, rgba(15, 17, 24, 0.98) 0%, rgba(15, 17, 24, 0.95) 100%);

  will-change: transform;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;

  &.is-scrolled {
    background: @glass-bg;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
    border-bottom-color: rgba(255, 255, 255, 0.05);
  }

  &.is-hidden {
    transform: translateY(-100%);
    border-bottom-color: transparent;
  }

  .header-container {
    max-width: 1920px;
    height: 100%;
    margin: 0 auto;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  .logo {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }

    img {
      height: 36px;
      width: auto;
      object-fit: contain;
      filter: drop-shadow(0 0 8px rgba(14, 165, 233, 0.3));
    }
  }

  .middle-section {
    display: flex;
    align-items: center;
    gap: 32px;
    flex: 1;
    justify-content: center;

    .main-nav {
      flex-shrink: 0;
      height: 100%;

      &.hidden {
        display: none;
      }

      ul {
        margin: 0;
        padding: 0;
        height: 100%;
        display: flex;
        align-items: center;
        gap: 4px;

        li {
          font-size: 14px;
          color: @text-secondary;
          height: 100%;
          line-height: 60px;
          padding: 0 16px;
          list-style: none;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          white-space: nowrap;
          font-weight: 500;
          border-radius: 4px 4px 0 0;

          &:hover,
          &.active {
            color: @primary-light;
            background: rgba(14, 165, 233, 0.08);
          }

          &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 2px;
            background: linear-gradient(90deg, @primary, @primary-light);
            transition: width 0.3s ease;
            border-radius: 2px;
          }

          &:hover::after,
          &.active::after {
            width: 60%;
          }

          &.active {
            text-shadow: 0 0 20px rgba(14, 165, 233, 0.5);
          }
        }
      }
    }
  }

  .right-section {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-shrink: 0;

    .user-skeleton {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 0 8px;

      .skeleton-circle {
        width: 32px;
        height: 32px;
        border-radius: 10%;
        background: linear-gradient(90deg, rgba(148, 163, 184, 0.1) 25%, rgba(148, 163, 184, 0.2) 50%, rgba(148, 163, 184, 0.1) 75%);
        background-size: 200% 100%;
        animation: shimmer 1.5s infinite;
      }

      .skeleton-line {
        width: 80px;
        height: 12px;
        border-radius: 4px;
        background: linear-gradient(90deg, rgba(148, 163, 184, 0.1) 25%, rgba(148, 163, 184, 0.2) 50%, rgba(148, 163, 184, 0.1) 75%);
        background-size: 200% 100%;
        animation: shimmer 1.5s infinite;
      }
    }
  }

  .notification-icon {
    position: relative;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: @text-secondary;
    cursor: pointer;
    border-radius: 10%;
    transition: all 0.3s ease;
    z-index: 101;
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(255, 255, 255, 0.05);

    &:hover {
      background: rgba(14, 165, 233, 0.1);
      color: @primary-light;
      border-color: rgba(14, 165, 233, 0.3);
      transform: translateY(-1px);
    }

    .el-icon-message-solid {
      font-size: 18px;
    }

    .notification-badge {
      position: absolute;
      top: -4px;
      right: -4px;
      min-width: 18px;
      height: 18px;
      background: linear-gradient(135deg, @notification-red, #f87171);
      color: white;
      font-size: 11px;
      line-height: 18px;
      font-weight: bold;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 5px;
      box-shadow: 0 2px 8px rgba(239, 68, 68, 0.4);
      border: 2px solid @base-deep;
    }

    .notification-panel {
      position: absolute;
      top: calc(100% + 12px);
      right: 0;
      width: 400px;
      background: rgba(30, 41, 59, 0.98);
      border: 1px solid rgba(255, 255, 255, 0.08);
      border-radius: 12px;
      box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
      z-index: 1000;
      overflow: hidden;
      transform-origin: top right;
      animation: dropdownShow 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      backdrop-filter: blur(20px);

      .notification-header {
        padding: 16px 20px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.06);
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: rgba(0, 0, 0, 0.2);

        h3 {
          margin: 0;
          font-size: 16px;
          color: @text-primary;
          font-weight: 600;
          letter-spacing: 0.5px;
        }

        .notification-actions {
          display: flex;
          gap: 16px;

          span {
            font-size: 13px;
            color: @primary;
            cursor: pointer;
            transition: all 0.2s;
            font-weight: 500;

            &:hover {
              color: @primary-light;
              text-decoration: underline;
              text-underline-offset: 3px;
            }

            &.clear-all {
              color: @text-secondary;

              &:hover {
                color: @notification-red;
              }
            }
          }
        }
      }

      .notification-list {
        max-height: 420px;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-thumb {
          background: rgba(148, 163, 184, 0.2);
          border-radius: 3px;
        }

        .notification-item {
          padding: 14px 20px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.04);
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          transition: all 0.2s ease;
          position: relative;

          &.unread {
            background: linear-gradient(90deg, @unread-bg, transparent);
            border-left: 3px solid @primary;
          }

          &:hover {
            background: rgba(255, 255, 255, 0.03);
            transform: translateX(2px);
          }

          .notification-content {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 6px;

            .notification-dot {
              position: absolute;
              left: 8px;
              top: 50%;
              transform: translateY(-50%);
              width: 6px;
              height: 6px;
              background: @primary;
              border-radius: 50%;
              box-shadow: 0 0 8px @primary;
            }

            .notification-text {
              margin: 0 0 0 12px;
              font-size: 14px;
              color: @text-primary;
              line-height: 1.5;
              font-weight: 400;
            }

            .notification-time {
              font-size: 12px;
              color: @text-secondary;
              margin-left: 12px;
              font-weight: 300;
            }
          }

          .notification-action {
            margin-left: 12px;
            flex-shrink: 0;

            .mark-read-btn {
              font-size: 12px;
              color: @primary;
              cursor: pointer;
              padding: 4px 10px;
              border-radius: 6px;
              background: rgba(14, 165, 233, 0.1);
              transition: all 0.2s;
              font-weight: 500;
              white-space: nowrap;

              &:hover {
                background: rgba(14, 165, 233, 0.2);
                color: @primary-light;
                transform: scale(1.05);
              }
            }

            .read-status {
              font-size: 12px;
              color: @text-secondary;
              padding: 4px 10px;
            }
          }
        }
      }

      .empty-notification {
        padding: 50px 20px;
        text-align: center;
        color: @text-secondary;

        i {
          font-size: 48px;
          margin-bottom: 16px;
          opacity: 0.3;
          display: block;
        }

        p {
          margin: 0;
          font-size: 14px;
          letter-spacing: 0.5px;
        }
      }
    }
  }

  .user-area {
    display: flex;
    align-items: center;
    margin: 0;

    .login-btn {
      height: 36px;
      line-height: 36px;
      padding: 0 20px;
      background: transparent;
      border: 1px solid @primary;
      border-radius: 6px;
      color: @primary;
      cursor: pointer;
      transition: all 0.3s ease;
      font-weight: 500;
      font-size: 14px;
      letter-spacing: 0.5px;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(14, 165, 233, 0.2), transparent);
        transition: left 0.5s;
      }

      &:hover {
        background: rgba(14, 165, 233, 0.1);
        color: @primary-light;
        border-color: @primary-light;
        box-shadow: 0 0 20px rgba(14, 165, 233, 0.3);

        &::before {
          left: 100%;
        }
      }
    }

    .avatar-container {
      position: relative;
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 4px 12px 4px 4px;
      height: 44px;
      border-radius: 22px;
      transition: all 0.3s ease;
      background: rgba(255, 255, 255, 0.02);
      border: 1px solid transparent;
      gap: 8px;

      &:hover {
        background: rgba(14, 165, 233, 0.08);
        border-color: rgba(14, 165, 233, 0.2);
        box-shadow: 0 4px 20px rgba(14, 165, 233, 0.15);
      }

      .user-coins {
        font-size: 13px;
        color: #fbbf24;
        margin-right: 4px;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 4px;

        i {
          font-size: 14px;
        }
      }

      .user-avatar {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        object-fit: cover;
        border: 2px solid rgba(255, 255, 255, 0.1);
        transition: all 0.3s;

        &:hover {
          border-color: @primary;
          transform: scale(1.1);
        }
      }

      .icon-arrow-down {
        color: @text-secondary;
        font-size: 12px;
        transition: transform 0.3s;
        margin-left: 2px;

        &.rotate {
          transform: rotate(180deg);
        }
      }

      .user-name {
        font-size: 14px;
        color: @text-secondary;
        font-weight: 500;
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .user-menu {
        position: absolute;
        top: calc(100% + 12px);
        right: 0;
        width: 180px;
        background: rgba(30, 41, 59, 0.98);
        border: 1px solid rgba(255, 255, 255, 0.08);
        border-radius: 12px;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
        z-index: 1000;
        overflow: hidden;
        animation: dropdownShow 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        backdrop-filter: blur(20px);

        .menu-item {
          padding: 12px 16px;
          color: @text-secondary;
          font-size: 14px;
          transition: all 0.2s;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 10px;
          font-weight: 500;

          i {
            font-size: 16px;
            width: 20px;
            text-align: center;
            color: @text-secondary;
            transition: color 0.2s;
          }

          &:hover {
            background: rgba(14, 165, 233, 0.1);
            color: @primary-light;
            padding-left: 20px;

            i {
              color: @primary-light;
            }
          }

          &.logout {
            color: @notification-red;

            i {
              color: @notification-red;
            }

            &:hover {
              background: rgba(239, 68, 68, 0.1);
            }
          }
        }

        .divider {
          height: 1px;
          background: rgba(255, 255, 255, 0.06);
          margin: 8px 0;
        }
      }
    }
  }

  .mobile-menu-btn {
    width: 40px;
    height: 40px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 10%;
    color: @text-primary;
    cursor: pointer;
    display: none;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    font-size: 18px;

    &:hover {
      background: rgba(14, 165, 233, 0.1);
      border-color: rgba(14, 165, 233, 0.3);
      color: @primary-light;
    }

    @media (max-width: @md) {
      display: flex;
    }
  }

  .submenu,
  .kind {
    position: absolute;
    background-color: rgba(49, 49, 49, 0.9);
    box-shadow: 0 4px 20px #0000004d;
    padding: 16px 0 0 16px;
    border-radius: 4px;
    display: none;
    z-index: 101;

    .submenu_filter {
      float: left;
      display: inline-block;
    }
  }

  .submenu {
    width: 346px;
    height: 296px;
    top: 100%;
    left: 0;
    border-radius: 4px 0 0 4px;

    .submenu_filter {
      width: 150px;
      height: 56px;
      line-height: 56px;
    }
  }

  .kind {
    width: 746px;
    height: 296px;
    top: 100%;
    left: 346px;
    border-radius: 0 4px 4px 0;

    .submenu_filter {
      width: 136px;
      height: 50px;
      line-height: 50px;
    }
  }

  .nav-item:hover .submenu,
  .nav-item:hover .kind {
    display: block;
  }

  .anchor-link {
    display: block;
    width: 100%;
    height: 100%;
    color: #cbcbcb;
    text-decoration: none;
    transition: all 0.3s;
    padding-left: 30px;
    box-sizing: border-box;

    &:hover {
      background-color: rgba(255, 255, 255, 0.08);
      color: @primary-light;
      border-radius: 4px;
    }
  }

  .highlight-text {
    color: #ff0000;
    font-weight: 600;
  }

  .mobile-nav-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: none;

    &.show {
      display: block;
    }
  }

  .mobile-nav {
    position: fixed;
    top: 0;
    right: 0;
    width: 280px;
    height: 100%;
    background-color: @base-darker;
    z-index: 1000;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    overflow-y: auto;
    border-left: 1px solid @border-color;

    &.show {
      transform: translateX(0);
    }

    .mobile-nav-header {
      height: 60px;
      padding: 0 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid @border-color;

      .mobile-nav-title {
        font-size: 16px;
        color: @text-primary;
        font-weight: 600;
      }

      .close-btn {
        width: 36px;
        height: 36px;
        background-color: transparent;
        border: none;
        color: @text-secondary;
        font-size: 20px;
        cursor: pointer;

        &:hover {
          color: @primary-light;
        }
      }
    }

    .mobile-nav-list {
      padding: 15px;
      list-style: none;

      li {
        padding: 12px 0;
        border-bottom: 1px solid @border-color;
        color: @text-secondary;
        cursor: pointer;
        font-size: 15px;

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          color: @primary-light;
        }

        .arrow-icon {
          float: right;
          font-size: 12px;
          transition: transform 0.3s ease;

          &.rotate {
            transform: rotate(90deg);
          }
        }

        .mobile-submenu {
          list-style: none;
          padding: 10px 0 0 15px;
          margin: 0;

          li {
            padding: 8px 0;
            font-size: 14px;
            border-bottom: none;

            &:hover {
              color: @primary-light;
              background-color: rgba(14, 165, 233, 0.1);
              padding-left: 5px;
            }
          }
        }
      }
    }
  }

  @media (min-width: @xxl) {
    .header-container {
      padding: 0 40px;
    }

    .main-nav ul li {
      padding: 0 20px;
    }
  }

  @media (max-width: @lg) {
    .middle-section {
      gap: 20px;
    }
  }

  @media (max-width: @md) {
    .middle-section {
      justify-content: flex-end;
      gap: 10px;

      .main-nav {
        display: none;
      }
    }

    .user-area {

      .user-coins,
      .user-name {
        display: none;
      }
    }

    .notification-panel {
      width: 320px !important;
      right: -80px !important;
    }

    .kind {
      left: 0;
      top: 320px;
      width: 346px;
      height: auto;
      max-height: 300px;
      overflow-y: auto;
    }
  }

  @media (max-width: @sm) {
    .notification-panel {
      width: 280px !important;
      right: -60px !important;
    }

    .avatar-container {
      padding: 4px !important;

      .user-avatar {
        width: 32px !important;
        height: 32px !important;
      }

      .icon-arrow-down {
        display: none;
      }
    }

    .submenu,
    .kind {
      width: 280px !important;
    }

    .kind {
      top: 280px;
    }
  }
}

@keyframes dropdownShow {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}
</style>